module.exports = __webpack_public_path__ + "static/media/8_of_diamonds.543cac76.png";